import { GeneralSettings } from "./store_settings_tabs/GeneralSettings";
import { InventoryManagementSettings } from "./store_settings_tabs/InventoryManagementSettings";
import { TabbedInterface } from "../../../components/layout/tabbed-interface/TabbedInterface";
import { useTranslation } from "../../../hooks/useTranslation";
import { DangerZone } from "./store_settings_tabs/DangerZone";

const tabs = [
  {
    label: "generalSettings",
    path: "general",
    component: <GeneralSettings />,
  },
  /* {
      label: "orderManagement",
      path: "order-management",
      component: <OrderManagementSettings />,
    },*/
  {
    label: "inventoryManagement",
    path: "inventory",
    component: <InventoryManagementSettings />,
  },
  {
    label: "dangerZone",
    path: "danger-zone",
    component: <DangerZone />,
  },
  /*
    {
      label: "autopricerSettings",
      path: "smart-pricing",
      component: <SmartPriceSettings />,
    },
    
    {
      label: "customerInvoiceInfo",
      path: "invoice",
      component: <InvoiceSettings />,
    },
    */
];

export const StoreSettings = () => {
  const { translate } = useTranslation("pages.stores.settings.tab");

  return (
    <TabbedInterface tabs={tabs} defaultPath="general" translate={translate} />
  );
};
